import { render, staticRenderFns } from "./ProductUpdatePrice.vue?vue&type=template&id=be5310f8&scoped=true&"
import script from "./ProductUpdatePrice.vue?vue&type=script&lang=js&"
export * from "./ProductUpdatePrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpdatePrice.vue?vue&type=style&index=0&id=be5310f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5310f8",
  null
  
)

export default component.exports